import { render, staticRenderFns } from "./WorkPlaceCreate.vue?vue&type=template&id=d0c9f6e6"
import script from "./WorkPlaceCreate.vue?vue&type=script&lang=js"
export * from "./WorkPlaceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports